import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/lilith2.svg'; // Pfad zu deinem Logo anpassen
import './Header.css';

const Header: React.FC = () => {
    const location = useLocation();
    const isHomePage = location.pathname === '/';

    return (
        <div className="header-container">
            {/* Logo – führt immer zur Startseite */}
            <Link to="/" className="logo-container">
                <img src={logo} alt="Lilith Logo" className="logo-img" />
            </Link>

            {/* Navigation */}
            <div className="nav-item-container">
                {/* 1. SCROLL-ANKER (Alle für Abschnitte auf der Startseite) */}
                <a href={isHomePage ? "#us" : "/#us"}><p>ABOUT US</p></a>
                <a href={isHomePage ? "#impressum" : "/#impressum"}><p>IMPRESSUM</p></a>
                <Link to="/menu"><p>MENU</p></Link>
                {/*<a href={isHomePage ? "#gallerie" : "/#gallerie"}><p>GALLERY</p></a>*/}

            </div>
            <div className="header-spacer"></div>
        </div>
    );
};

export default Header;